// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

const CustomTooltip = (props: any) => {
  const { active, payload, units } = props;
  const theme = useTheme();
  const { surface, onSurface, outline } = getSurfaceTokens(theme);

  const dataKey = payload?.[0]?.dataKey;
  const value = payload?.[0]?.payload?.[dataKey];

  if (!active || !value) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "8px",
        backgroundColor: surface,
        color: onSurface,
        border: `1px solid ${outline}`,
        borderRadius: "4px",
        alignItems: "center",
      }}
    >
      <Typography fontSize="14px">
        {value}
        {units !== "%" ? ` ${units}` : units}
      </Typography>
    </Box>
  );
};

export default CustomTooltip;
